<template>
  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <div v-if="allPlan == null || tablePrice == null" class="priceLoaderWrapper">
      <v-progress-circular :size="40" :width="3" color="#787ff7" indeterminate></v-progress-circular>
    </div>
    <div v-else class="priceWrapper mt-9">
      <div class="d-flex flex-wrap justify-center align-center">
        <div class="priceCardWrapper mb-3 px-3" v-for="(item, i) in cardItems" :key="i">
          <div class="priceCard">
            <v-card :class="item.focus ? 'priceCardFocus' : 'priceCardTop'">
              <div class="priceCardType">
                {{ item.character }} тэмдэгт
              </div>
              <div style="min-height:100px">
                <div class="listWrapper" v-for="(item, i) in item.planWork" :key="i">
                  <span>
                    <v-icon class="icon">mdi-check</v-icon>
                  </span>
                  <span class="listTitle">{{ $t(item) }}</span>
                </div>
                <div class="d-flex mb-4 justify-center">
                  <span class="price">{{ itemPrice[i]
                  }}</span>
                  <span class="currency">₮</span>
                </div>
                <v-btn class="btnStyle" @click="jump" :disabled="buyLoading">
                  <span style="color:#ffffff">{{
                      $t("footer.getPlanBtn")
                  }}</span>
                </v-btn>
              </div>
            </v-card>
          </div>
        </div>
      </div>
      <div class="instruction">
        <span style="color:red">*</span> {{ $t("plan.instruction1") }}
      </div>

      <v-dialog v-model="successShowDialog" transition="dialog-top-transition" max-width="600">
        <!-- <template v-slot:default="dialog"> -->
        <v-card>
          <div class="titleBar">{{ $t("plan.getPlan") }}</div>
          <v-card-text class="d-flex-column pt-5 align-center">
            <div class="dialogTextStyle" style="margin-left:8px">
              {{ $t("plan.successPlan") }}
            </div>
            <div class="dialogTextStyle">
              Таны "БОЛОР ХЭТЭВЧ"-ээс
              <span class="priceDialogStyle">{{ currentPayPrice }}₮</span>
              хасагдаж, {{ currentPage }} тэгмдэгт хөрвүүлэх эрх нэмэгдлээ.
            </div>
          </v-card-text>
          <v-card-actions class="justify-start">
            <v-btn class="btnStyle" @click="redirectPage()">{{
                $t("plan.okBtn")
            }}</v-btn>
          </v-card-actions>
        </v-card>
        <!-- </template> -->
      </v-dialog>
      <v-dialog v-model="warningShowDialog" transition="dialog-top-transition" max-width="400">
        <v-card>
          <div class="titleBar">
            <v-icon color="red">mdi-alert</v-icon>
            <span class="ml-2">{{ $t("plan.warnMsg1") }}</span>
          </div>
          <v-card-text class="d-flex-column pt-10 align-center">
            <div class="dialogTextStyle">
              {{ $t("plan.warnMsg2") }}
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="closeBtn" @click="warningShowDialog = false">{{
                $t("plan.closeBtn")
            }}</v-btn>
            <v-btn class="btnStyle" :disabled="changeLoading" @click="changeCustomerPlan">
              <span v-if="changeLoading">
                <v-progress-circular :size="25" :width="3" color="#ffffff" indeterminate></v-progress-circular>
              </span>
              <span v-else>{{ $t("plan.activate") }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
export default {
  name: "Plan",
  data() {
    return {
      cardItems: [
        {
          character :"500",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"5,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"12,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"25,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"200,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"2,000,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },

      ],
      itemPrice: ["1,000", "5,000", "10,000", "20,000", "100,000", "800,000"],
      plans: null,
      successShowDialog: false,
      warningShowDialog: false,
      isPriceModal: false,
      loading: false,
      currentPayPrice: 0,
      currentPage: 0,
      userBalance: 0,
      changeLoading: false,
    };
  },
  computed: {
    ...mapState(["customerPlan", "allPlan", "tablePrice"]),
    getToken: function () {
      return this.$cookie.get("token");
    },
  },
  methods: {
    ...mapActions([
      "updateCustomerPlan",
      "showErrorMessage",
      "showSuccessMessage",
      "showWarningMessage",
      "checkError",
    ]),
    checkBalance(pId, price, page) {
      this.loading = true;
      const headers = { token: this.getToken, ptype: pId, quantity: 1 };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getwalletinfo`, {
          headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.currentPayPrice = price;
            this.currentPage = page;
            this.getPurchase(pId);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorShowDialog = true;
          this.checkError(error);
        });
    },

    changeCustomerPlan() {
      this.changeLoading = true;
      const headers = {
        token: this.getToken,
      };
      axios
        .post(`${process.env.VUE_APP_BASE_URL}/changePlan`, this.changePlanId, {
          headers,
        })
        .then((response) => {
          if (response.status == 200) {
            let plan = this.allPlan.find(
              (plan) => plan.ID == response.data.data.PlanID
            );
            this.showSuccessMessage({
              message: "Таны эрх " + plan.Name + " болж өөрчлөгдлөө",
              timeout: 3000,
            });
            this.updateCustomerPlan(response.data.data);
            this.warningShowDialog = false;
          }
          this.changeLoading = false;
        })
        .catch((error) => {
          this.warningShowDialog = false;
          this.changeLoading = false;
          this.checkError(error);
        });
    },

    getPurchase(pId) {
      const headers = { token: this.getToken, ptype: pId, quantity: 1 };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/paywithwallet`, {
          headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.loading = false;
            this.successShowDialog = true;
            this.showSuccessMessage({
              message: "Эрх амжилттай сунгагдлаа",
              timeout: 3000,
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.checkError(error);
          this.errorShowDialog = true;
        });
    },
    jump() {
      localStorage.setItem("isPriceModel" , true)
      window.location.href = process.env.VUE_APP_BASE_URL + "/login";
    },

    redirectPage() {
      this.successShowDialog = false;
      if (this.$route.name != "payment") {
        this.$router.push({ name: "groups" });
      }
    },
    getFormatNumber(number) {
      return Intl.NumberFormat().format(number);
    },
    showWarningDialog(planId) {
      this.warningShowDialog = true;
      this.changePlanId = planId;
    },
  },
};
</script>
<style scoped>
.priceWrapper {
  max-width: 80vw;
  display: flex;
  grid-column: 3;
  width: 100%;
  align-items: center;
  align-content: center;
  flex-direction: column;
  margin: 10px;
}

.priceLoaderWrapper {
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.priceCardWrapper {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 33%;
  max-width: 23%;
  min-width: 300px;
  margin: 2%;
}

@media screen and (max-width: 650px) {
  .priceCardWrapper {
    width: 300px;
  }
}

.priceCard {
  /* min-height: 348px !important; */
  /* padding: 24px; */
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
  border-bottom: 2px solid #adb5bd !important;
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #ffffff;
  color: #2a2a2b;
}

.priceCardTop {
  min-height: 348px !important;
  padding: 24px;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
  /* border-bottom: 3px solid #adb5bd !important; */
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #f7f6ff;
  color: #2a2a2b;
}

.priceCardBottom {
  padding: 24px;
  font-weight: 500;
  text-align: left;
  line-height: 1.5;
  font-size: 14px;
  color: #2c3e50aa;
}

.priceCardBottomTitle {
  margin-bottom: 12px;
}

/* .priceCard:hover {
  background-color: #ffffff;
  border-bottom: 3px solid #787ff7 !important;
  transition: all 0.5s ease !important;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
} */

.priceCardFocus {
  padding: 48px 24px;
  box-shadow: 0 0 10px rgba(60, 72, 88, 0.529) !important;
  /* border-bottom: 3px solid #adb5bd !important; */
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #ffffff;
  color: #2a2a2b;
  border: 1px solid #787ff7;
}

.priceCardType {
  font-weight: 700;
  /* color: #787ff7; */
  line-height: 1.5;
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.price {
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
  font-size: 40px;
  color: #2c3e50;
  padding-top: 10px;
}

.currency {
  font-weight: 600;
  font-size: 20px;
  padding-top: 10px;
  color: #2c3e50;
}

.day {
  font-weight: 700;
  text-align: left;
  line-height: 1.5;
  font-size: 20px;
  color: #2c3e50;
  margin-top: 11px;
}

.limit {
  font-weight: 500;
  text-align: right;
  line-height: 1.5;
  font-size: 9px;
  color: #2c3e50;
}

.listWrapper {
  display: flex;
  align-items: left;
}

.icon {
  color: #787ff7;
  margin-right: 20px;
}

.listTitle {
  color: #2c3e50a6;
  font-weight: 500;
  line-height: 1.5;
  font-size: 16px;
  text-align: left;
}

.btnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: 20px; */
  margin: 20px auto 0px auto;
}

.btnStyle {
  background-color: #787ff7 !important;
  color: #ffffff;
  /* box-shadow: 0 3px 5px 0 rgba(50, 50, 247, 0.3); */
  padding: 8px 20px !important;
  outline: none;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s;
  font-weight: 500;
  border-radius: 6px;
  text-transform: capitalize;
  width: 100%;
}

.instruction {
  display: inline-block;
  text-align: right;
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 15px;
  padding-right: 20px;
}

.instructionCard {
  padding: 24px;
  border-bottom: 3px solid #adb5bd !important;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
}

.instructionCard:hover {
  border-bottom: 3px solid #787ff7 !important;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
}

.instructionCardTitle {
  font-weight: 500;
  text-align: left;
  line-height: 1.5;
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 20px;
}

.instructionCardDesc {
  text-align: justify;
  line-height: 1.5;
  font-size: 16px;
  color: #2c3e50;
}

.dialogTextStyle {
  color: #2c3e50;
  /* color: red; */
  font-size: 16px;
}

.titleBar {
  font-weight: 500;
  font-size: 18px;
  border-bottom: 1px solid #e8e8e8;
  height: 58px !important;
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.priceDialogStyle {
  font-weight: 700;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

td,
th {
  border: 1px solid #dddddda7;
  text-align: left;
  padding: 8px;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 10px;
  height: 34px !important;
  width: 64px !important;
}
</style>
